import React from 'react'
import data from '../../json/areas.json'
import AreaCard from './AreaCard';
function Areas() {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full lg:w-2/3">
          {data.map((cardData, index) => (
            <AreaCard
              key={index}
              title={cardData.title}
              phones={cardData.phones}
              email={cardData.email}
              address={cardData.address}
              links={cardData.links}
            />
          ))}
        </div>
      );
}

export default Areas